import {
  jb_time_picker_css_default
} from "./chunk.C2UVFMYN.js";
import {
  FormElement
} from "./chunk.MEO2C6ZS.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-time-picker/jb-time-picker.ts
var JbTimePicker = class extends Initiable(FormElement(r)) {
  constructor() {
    super(...arguments);
    this._dialResizeObserver = null;
    this._initialValue = "";
    this._nearestDiv = null;
    this._placeholderWithValue = "";
    this._showHours = true;
    this._xCoordinatesTime = 0;
    this._yCoordinatesTime = 0;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("mousedown", this._onMouseOrTouchDown);
    this.removeEventListener("touchstart", this._onMouseOrTouchDown);
    document.removeEventListener("click", this._documentClickHandler.bind(this));
    this._dialResizeObserver?.disconnect();
  }
  async firstUpdated() {
    this._placeholderWithValue = this.value ? this.value : this.placeholder;
    this._initialValue = this.value || (/* @__PURE__ */ new Date()).toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" });
    this._setInitialMinuteLine(this._findElementByText(this.value.substring(3, 5)));
    this.addEventListener("mousedown", this._onMouseOrTouchDown);
    this.addEventListener("touchstart", this._onMouseOrTouchDown);
    document.addEventListener("click", this._documentClickHandler.bind(this));
    document.addEventListener("keydown", this._handleKeyDown.bind(this));
    this._setupObservers();
  }
  _addFocus(div) {
    this.renderRoot.querySelectorAll(".time").forEach((el) => el.classList.remove("focus"));
    div.classList.add("focus");
  }
  _clickCancel() {
    this.value = this._pickerInput.value ? this._pickerInput.value : this._initialValue;
    this._showHoursDial();
    this.dispatchEvent(new CustomEvent("jb-time-picker:cancel"));
    this._timePickerIsActive = false;
  }
  _clickOK() {
    this.value = this.value ? this.value : this._initialValue;
    this._pickerInput.value = this.value;
    this._showHoursDial();
    this.dispatchEvent(new CustomEvent("jb-time-picker:ok", { detail: { value: this.value } }));
    this._timePickerIsActive = false;
  }
  _documentClickHandler(event) {
    if (!this._timePickerIsActive) return;
    const path = event.composedPath();
    const isClickInside = path.includes(this);
    if (!isClickInside) {
      this._clickCancel();
    }
  }
  _findElementByText(text) {
    let normalizedText = text.replace(/^0+/, "");
    if (this._showHours && normalizedText === "") {
      normalizedText = "24";
    }
    if (!this._showHours && normalizedText === "") {
      normalizedText = "0";
    }
    const selector = this._showHours ? ".hours .time" : ".minutes .time";
    return [...this.shadowRoot.querySelectorAll(selector)].filter((div) => div.getBoundingClientRect().width > 0 && div.getBoundingClientRect().height > 0).find((div) => div.innerText.trim() === normalizedText);
  }
  _findNearestDiv(mouseX, mouseY) {
    const divs = Array.from(this.shadowRoot.querySelectorAll(".time"));
    const dial = this._dial.getBoundingClientRect();
    return divs.reduce(
      (nearestDiv, div) => {
        const rect = div.getBoundingClientRect();
        const divX = rect.left + rect.width / 2 - dial.left - dial.width / 2;
        const divY = rect.top + rect.height / 2 - dial.top - dial.height / 2;
        const distance = Math.sqrt((mouseX - divX) ** 2 + (mouseY - divY) ** 2);
        return distance < nearestDiv.distance ? { div, distance } : nearestDiv;
      },
      { div: null, distance: Infinity }
    ).div;
  }
  _getHours() {
    const hours = [];
    const dialRect = this._dial?.getBoundingClientRect() || { width: 0, height: 0 };
    const dialCenterX = dialRect.width / 2;
    const dialCenterY = dialRect.height / 2;
    for (let i = 1; i < 25; i += 1) {
      const angle = 2 * Math.PI / 12 * (i - 3);
      const radius = i <= 12 ? dialRect.width * 0.4 : dialRect.width * 0.28;
      const x = dialCenterX + radius * Math.cos(angle);
      const y = dialCenterY + radius * Math.sin(angle);
      hours.push(
        ke`<div
          class="time"
          style="left: ${x}px; top: ${y}px; transform: translate(-50%, -50%);"
          @mousedown=${this._onMouseOrTouchDown}
          @touchstart=${this._onMouseOrTouchDown}
        >
          <div class="digit">${i}</div>
        </div>`
      );
    }
    return hours;
  }
  _getMinutes() {
    const minutes = [];
    const dialRect = this._dial?.getBoundingClientRect() || { width: 0, height: 0 };
    const dialCenterX = dialRect.width / 2;
    const dialCenterY = dialRect.height / 2;
    const radius = dialRect.width * 0.4;
    for (let i = 0; i < 60; i += 1) {
      const angle = 2 * Math.PI / 60 * (i - 15);
      const x = dialCenterX + radius * Math.cos(angle);
      const y = dialCenterY + radius * Math.sin(angle);
      const isMajorMinute = i % 5 === 0;
      minutes.push(
        ke`<div
          class="time ${isMajorMinute ? "" : "transparent"} "
          style="left: ${x}px; top: ${y}px; transform: translate(-50%, -50%);"
          @mousedown=${this._onMouseOrTouchDown}
          @touchstart=${this._onMouseOrTouchDown}
        >
          ${i}
        </div>`
      );
    }
    return minutes;
  }
  _getMouseOrTouchEvent(event) {
    return event instanceof MouseEvent ? { clientX: event.clientX, clientY: event.clientY } : { clientX: event.touches[0].clientX, clientY: event.touches[0].clientY };
  }
  _handleKeyDown(event) {
    if (event.key === "Escape" && this._timePickerIsActive) {
      this._clickCancel();
      this._pickerInput.blur();
    } else if (event.key === "Enter" && this._timePickerIsActive) {
      this._clickOK();
      this._pickerInput.blur();
    }
  }
  _isInsideDial(mouseX, mouseY) {
    const dialRect = this._dial.getBoundingClientRect();
    const dialCenterX = dialRect.left + dialRect.width / 2;
    const dialCenterY = dialRect.top + dialRect.height / 2;
    const distance = Math.hypot(mouseX - dialCenterX, mouseY - dialCenterY);
    return distance <= dialRect.width / 2;
  }
  _onMouseOrTouchDown(event) {
    const { clientX, clientY } = this._getMouseOrTouchEvent(event);
    if (this._isInsideDial(clientX, clientY)) {
      this.addEventListener("mouseup", this._onMouseOrTouchUp);
      this.addEventListener("mousemove", this._onMouserOrTouchMove);
      this.addEventListener("touchmove", this._onMouserOrTouchMove);
      this.addEventListener("touchend", this._onMouseOrTouchUp);
      this._updateCoordinates(event);
    }
  }
  _onMouseOrTouchUp() {
    this.removeEventListener("mousemove", this._onMouserOrTouchMove);
    this.removeEventListener("touchmove", this._onMouserOrTouchMove);
    this.removeEventListener("mouseup", this._onMouseOrTouchUp);
    this.removeEventListener("touchend", this._onMouseOrTouchUp);
    const timeValue = parseInt(this._nearestDiv.textContent, 10);
    if (this._nearestDiv.parentElement.classList.contains("hours")) {
      this._setHour(timeValue);
      this._showMinutesDial();
    } else if (this._nearestDiv.parentElement.classList.contains("minutes")) {
      this._setMinute(timeValue);
    }
  }
  _onMouserOrTouchMove(event) {
    const { clientX, clientY } = this._getMouseOrTouchEvent(event);
    if (this._isInsideDial(clientX, clientY)) {
      this._updateCoordinates(event);
      const timeValue = parseInt(this._nearestDiv.textContent, 10) === 24 ? 0 : parseInt(this._nearestDiv.textContent, 10);
      if (this._showHours) {
        this.value = this.value ? timeValue.toString().padStart(2, "0") + this.value.substring(2, 5) : timeValue.toString().padStart(2, "0") + this._initialValue.substring(2, 5);
      } else {
        this.value = this.value ? this.value.substring(0, 3) + timeValue.toString().padStart(2, "0") : this._initialValue.substring(0, 3) + timeValue.toString().padStart(2, "0");
      }
    }
  }
  _runUpdateLogic() {
    this.requestUpdate();
    const valueToUpdate = this._showHours ? this._hourInput.value : this._minuteInput.value;
    this._updateLine(this._findElementByText(valueToUpdate));
  }
  // set the selecetd hour
  _setHour(hour) {
    const formattedHour = hour === 24 ? 0 : hour;
    this.value = this.value ? formattedHour.toString().padStart(2, "0") + this.value.substring(2, 5) : formattedHour.toString().padStart(2, "0") + this._initialValue.substring(2, 5);
    this._hourInput.value = formattedHour.toString().padStart(2, "0");
    this._updateLine(this._findElementByText(formattedHour.toString()));
  }
  async _setInitialMinuteLine(element) {
    await this.updateComplete;
    if (!element) {
      return;
    }
    const rect = element.getBoundingClientRect();
    this._yCoordinatesTime = rect.left + rect.width / 2 - this._dial.getBoundingClientRect().left - this._dial.getBoundingClientRect().width / 2;
    this._xCoordinatesTime = rect.top + rect.height / 2 - this._dial.getBoundingClientRect().top - this._dial.getBoundingClientRect().height / 2;
  }
  // set the selected minute
  _setMinute(minute) {
    this.value = this.value ? this.value.substring(0, 3) + minute.toString().padStart(2, "0") : this._initialValue.substring(0, 3) + minute.toString().padStart(2, "0");
    this._minuteInput.value = minute.toString().padStart(2, "0");
    this._updateLine(this._findElementByText(minute === 0 ? "0" : minute.toString()));
  }
  // Richtet MutationObserver und ResizeObserver für das Dial-Element ein.
  _setupObservers() {
    if (!this._dial) return;
    this._dialResizeObserver = new ResizeObserver(() => {
      if (window.getComputedStyle(this._dial).display !== "none") {
        this._runUpdateLogic();
      }
    });
    this._dialResizeObserver.observe(this._dial);
  }
  async _showHoursDial() {
    this._showHours = true;
    await this.updateComplete;
    const element = this._findElementByText(this._hourInput.value);
    if (element) {
      this._updateLine(element);
    } else {
      this.renderRoot.querySelectorAll(".time").forEach((el) => el.classList.remove("focus"));
    }
  }
  async _showMinutesDial() {
    this._showHours = false;
    await this.updateComplete;
    const element = this._findElementByText(this._minuteInput.value);
    if (element) {
      this._updateLine(element);
    } else {
      this.renderRoot.querySelectorAll(".time").forEach((el) => el.classList.remove("focus"));
    }
  }
  _updateCoordinates(event) {
    const rect = this.shadowRoot.querySelector(".dial").getBoundingClientRect();
    const { clientX, clientY } = this._getMouseOrTouchEvent(event);
    const mouseX = clientX - rect.left - rect.width / 2;
    const mouseY = clientY - rect.top - rect.height / 2;
    this._nearestDiv = this._findNearestDiv(mouseX, mouseY);
    if (this._nearestDiv) {
      this._updateLine(this._nearestDiv);
    }
  }
  async _updateLine(element) {
    await this.updateComplete;
    if (!element) {
      return;
    }
    const rect = element.getBoundingClientRect();
    this._xCoordinatesTime = rect.left + rect.width / 2 - this._dial.getBoundingClientRect().left - this._dial.getBoundingClientRect().width / 2;
    this._yCoordinatesTime = rect.top + rect.height / 2 - this._dial.getBoundingClientRect().top - this._dial.getBoundingClientRect().height / 2;
    this._addFocus(element);
  }
  render() {
    const hourClasses = { hours: this._showHours };
    const minuteClasses = { minutes: !this._showHours };
    const showPickerClasses = { show: this._timePickerIsActive };
    return ke`
      <div
        class="initial-input ${Rt({
      optional: !this.requiredText,
      error: this.showError || !!this.errorText
    })}"
      >
        <label>${this.label}${this.requiredText ? " *" : ""}</label>
        <jb-clock-icon></jb-clock-icon>
        <input
          type="text"
          .name="${this.name}"
          class="picker-input"
          .placeholder="${this._placeholderWithValue}"
          readonly
          tabindex="-1"
          @focusin=${() => {
      this._timePickerIsActive = true;
    }}
        />
        ${this.showError ? ke`<p>${this.requiredText}</p>` : D}
        ${this.errorText ? ke`<p>${this.errorText}</p>` : D}
      </div>
      <div class="time-picker ${Rt(showPickerClasses)}">
        <div class="time-picker-input">
          <div class="input-fields">
            <input
              class="hours"
              aria-label="${this.ariaLabelHourInput}"
              type="number"
              pattern="[0-9]*"
              max="23"
              min="0"
              .value="${this.value ? this.value?.substring(0, 2) : this._initialValue.substring(0, 2)}"
              @change=${(e2) => {
      e2.target.value = e2.target.value.length > 2 || e2.target.value > 23 || e2.target.value < 0 || Number.isNaN(parseInt(e2.target.value, 10)) ? this.value.substring(0, 2) || this._initialValue.substring(0, 2) : e2.target.value;
      this._setHour(parseInt(e2.target.value || "0", 10));
    }}
              @focusin=${() => {
      this._showHoursDial();
    }}
            />
            <div class="dots">
              <div>&#9679;</div>
              <div>&#9679;</div>
            </div>
            <input
              class="minutes"
              autocomplete="off"
              pattern="[0-9]*"
              type="number"
              .value="${this.value ? this.value?.substring(3, 5) : this._initialValue.substring(3, 5)}"
              max="59"
              min="0"
              aria-label="${this.ariaLabelMinuteInput}"
              @change=${(e2) => {
      e2.target.value = e2.target.value.length > 2 || e2.target.value > 59 || e2.target.value < 0 || Number.isNaN(parseInt(e2.target.value, 10)) ? this.value.substring(3, 5) || this._initialValue.substring(3, 5) : e2.target.value;
      this._setMinute(parseInt(e2.target.value || "0", 10));
    }}
              @focusin=${() => {
      this._showMinutesDial();
    }}
            />
          </div>

          <div class="dial">
            <svg
              viewBox="-100 -100 200 200"
              class="line"
            >
              <line
                x1="0"
                y1="0"
                x2="${this._xCoordinatesTime}"
                y2="${this._yCoordinatesTime}"
                stroke-width="3"
              />
            </svg>

            <div class="hours-dial ${Rt(hourClasses)}">${this._getHours()}</div>
            <div
              class="
                minutes-dial
                ${Rt(minuteClasses)}"
            >
              ${this._getMinutes()}
            </div>
            <div class="dot">&#9679;</div>
          </div>
        </div>
        <div class="actions">
          <jb-button-secondary
            @click="${this._clickCancel}"
            aria-label="${this.cancelButtonLabel}-Button"
            >${this.cancelButtonLabel}</jb-button-secondary
          >
          <jb-button-primary
            @click="${this._clickOK}"
            aria-label="${this.submitButtonLabel}-Button"
            >${this.submitButtonLabel}</jb-button-primary
          >
        </div>
      </div>
    `;
  }
};
JbTimePicker.styles = jb_time_picker_css_default;
__decorateClass([
  n()
], JbTimePicker.prototype, "ariaLabelHourInput", 2);
__decorateClass([
  n()
], JbTimePicker.prototype, "ariaLabelMinuteInput", 2);
__decorateClass([
  n()
], JbTimePicker.prototype, "cancelButtonLabel", 2);
__decorateClass([
  n()
], JbTimePicker.prototype, "placeholder", 2);
__decorateClass([
  n()
], JbTimePicker.prototype, "submitButtonLabel", 2);
__decorateClass([
  e(".dial")
], JbTimePicker.prototype, "_dial", 2);
__decorateClass([
  e(".hours")
], JbTimePicker.prototype, "_hourInput", 2);
__decorateClass([
  r2()
], JbTimePicker.prototype, "_initialValue", 2);
__decorateClass([
  e(".minutes")
], JbTimePicker.prototype, "_minuteInput", 2);
__decorateClass([
  r2()
], JbTimePicker.prototype, "_nearestDiv", 2);
__decorateClass([
  e(".picker-input")
], JbTimePicker.prototype, "_pickerInput", 2);
__decorateClass([
  r2()
], JbTimePicker.prototype, "_showHours", 2);
__decorateClass([
  r2()
], JbTimePicker.prototype, "_timePickerIsActive", 2);
__decorateClass([
  r2()
], JbTimePicker.prototype, "_xCoordinatesTime", 2);
__decorateClass([
  r2()
], JbTimePicker.prototype, "_yCoordinatesTime", 2);
JbTimePicker = __decorateClass([
  customElement("jb-time-picker")
], JbTimePicker);

export {
  JbTimePicker
};
